import css from './Filters.module.scss'
import React from 'react'
import { Range } from 'react-input-range'
import MediaQuery from 'react-responsive'

import { BreakpointsMaxWidth } from 'meta/layout/breakpoints'

import Desktop from 'components/Checkout/TicketSelection/Filters/Desktop'
import Mobile from 'components/Checkout/TicketSelection/Filters/Mobile'

interface IProps {
  setPriceRangeCallback(range: any): void
  priceRangeInitial: Range
  priceRangeCurrent: Range
}

const Filters: React.FC<IProps> = (props) => {
  const { priceRangeCurrent, priceRangeInitial, setPriceRangeCallback } = props

  return (
    <div className={css.checkout_ticketselection_filters_container}>
      <MediaQuery maxWidth={BreakpointsMaxWidth.mobile}>
        <Mobile
          priceRangeCurrent={priceRangeCurrent}
          priceRangeInitial={priceRangeInitial}
          setPriceRangeCallback={setPriceRangeCallback}
        />
      </MediaQuery>

      <MediaQuery minWidth={BreakpointsMaxWidth.mobile}>
        <Desktop
          priceRangeInitial={priceRangeInitial}
          priceRangeCurrent={priceRangeCurrent}
          setPriceRangeCallback={setPriceRangeCallback}
        />
      </MediaQuery>
    </div>
  )
}

export default Filters
